export default "__VITE_ASSET__d7770f5f__"